import React, { Component } from 'react';
import { BASE_URL_ADMIN } from '../../data/config'
import { do_action } from '../../actions'

class UploadListImage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            image: props.image || []
        }
    }

    selectFile = (event) => {
        const files = event.target.files

        if (this.state.image.length + files.length > 5) {
            alert('Upload maximum 5 image!');
            return;
        }

        for (let i = 0; i < files.length; i++) {
            let params = new FormData()
            params.append('image', files[i])
            do_action('upload_image', params)
                .then(resp => {
                    let url = resp.data.fileUrl;

                    this.setState(state => ({
                        image: state.image.concat([url])
                    }), () => {
                        this.props.updateImage(JSON.stringify(this.state.image))
                    });

                    
                })
                .catch(err => console.log(err))
        }
    }

    removeImage(idx) {
        let isAccept = window.confirm("Do you want remove this image!");
        if (isAccept == true) {
            let {image} = this.state
            image = image.filter((img, index) => {
                return index != idx
            })

            this.setState({
                image
            })

            this.props.updateImage(JSON.stringify(image))
        }
    }

    renderFileLabel = () => {
        if (!this.state.image.length) return 'Attach your image'
        return `${this.state.image.length} image selected`
    }

    renderThumbnail = (source) => source.map((item, idx) =>
        <li key={`image_${item}`}>
            <a href="#" style={{width: 120, height: 120}}><img className="thumbnail-quote" src={`${BASE_URL_ADMIN + item}`} alt="" style={{width: 120, height: 120}} /></a>
            <div className="last-down" onClick={this.removeImage.bind(this, idx)} style={{paddingTop: 40}}>
                <div><span className="fa fa-trash icon"></span></div>
                Remove
            </div>
        </li>
    )

    render() {
        return (
            <div className="side-a">
                <div className="ipn-file">
                    <input accept="image/*" onChange={this.selectFile.bind(this)} name="file" id="file" type="file" className="inputfile" data-multiple-caption="{count} files selected" multiple />
                    <label htmlFor="file">
                        <span>{this.renderFileLabel()}</span>
                    </label>
                </div>
                <span className="help-block">Suggested image dimensions: 650 x 230 pixels.</span>
                {(this.state.image.length) ? <ul className="list-inline list-img list-download">{this.renderThumbnail(this.state.image)}</ul> : null}
            </div>
        );
    }
}

export default UploadListImage;